<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iii"></a><strong>P<span class="small">LEASE</span> D<span class="small">ON’T</span><br/>W<span class="small">ISH</span> M<span class="small">E<br/>A</span> M<span class="small">ERRY</span> C<span class="small">HRISTMAS</span></strong></h1>
<p class="subtitle"><em>A Critical History<br/>of the Separation<br/>of Church and State</em></p>
<p class="author">Stephen M. Feldman</p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?f0275bd4